export const THEME_KEY = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TEXT: 'text',
    BACKGROUND: 'background',
    BLUR: 'blur',
    FONT: 'font',
    BACKGROUND_IMAGES: 'backgroundImages',
    IS_DEFAULT: 'isDefault'
};

export const FONT_SYSTEMS = ['Roboto', 'FS PF BeauSans Pro'];

export const VMP_THEME = {
    primary: '#CB002B',
    secondary: '#A0616A',
    text: '#44494d',
    blur: 0,
    font: 'Roboto',
    background: null,
    backgroundImages: [],
    isDefault: 1
};
